import { getRequestJSON } from '../api/index/location-api'

// The backend's REQUEST_CATEGORY_SETTINGS rows for one country and request
// type. Used at build time (lib/market-pages.js) and, when the build had none,
// in the browser before opening a booking form (components/market/MarketBooking).
// A failed or empty fetch must not fail the build or a click: never throws,
// returns [] instead.
export const getMarketRequestSettings = async (countryName, requestType) => {
    try {
        const all = await getRequestJSON(countryName)
        return Array.isArray(all) ? all.filter((c) => c.requestType === requestType) : []
    } catch (err) {
        console.error(`[market-settings] request settings unavailable for ${countryName}:`, err?.message)
        return []
    }
}
